import { clearUserSession } from './sessionManager';
import { NavigateFunction } from 'react-router-dom';

// Function to check if a response contains token-related errors
export const isTokenError = (errorMessage: string): boolean => {
  const tokenErrorKeywords = [
    'Invalid or expired token',
    'token',
    'expired',
    'unauthorized',
    'authentication failed',
    'invalid token',
    'token expired'
  ];
  
  const lowerErrorMessage = errorMessage.toLowerCase();
  return tokenErrorKeywords.some(keyword => 
    lowerErrorMessage.includes(keyword.toLowerCase())
  );
};

// Function to handle token errors consistently
export const handleTokenError = (errorMessage: string, navigate?: NavigateFunction): void => {
  if (isTokenError(errorMessage)) {
    clearUserSession(navigate);
  }
};

// Function to check response for token errors and handle them
export const checkResponseForTokenErrors = (
  response: any, 
  navigate?: NavigateFunction
): boolean => {
  // Check if response has an error property
  if (response && response.error) {
    if (isTokenError(response.error)) {
      handleTokenError(response.error, navigate);
      return true; // Token error was found and handled
    }
  }
  
  // Check if response is a string that might contain token errors
  if (typeof response === 'string' && isTokenError(response)) {
    handleTokenError(response, navigate);
    return true;
  }
  
  return false; // No token error found
}; 